export const SUBSCRIPTION_MOBILE_PHONE_NUMBER =
  process.env.REACT_APP_ZLICK_PHONE_NUMBER || ""
export const SUBSCRIPTION_MOBILE_CONFIRMATION_CODE =
  process.env.REACT_APP_ZLICK_CONFIRMATION_CODE || ""

export const SUBSCRIPTION_CREATE_MATCH = "/profile/subscriptions/new"
export const SUBSCRIPTION_UPGRADE_MATCH = "/profile/subscriptions/:id/upgrade"
export const SUBSCRIPTION_CANCEL_MATCH = "/profile/subscriptions/:id/cancel"
export const SUBSCRIPTION_PAY_MATCH = "/profile/subscriptions/:id/pay"

export const SUBSCRIPTION_SUCCESS_MATCH = "/subscription/success"
export const SUBSCRIPTION_FAILURE_MATCH = "/subscription/failed"

export const SUBSCRIPTION_CREATE_STEP_INITIAL = 0
export const SUBSCRIPTION_CREATE_STEP_PROVIDERS = 1
export const SUBSCRIPTION_CREATE_STEP_MOBILE_PAYMENT = 2
export const SUBSCRIPTION_CREATE_STEP_MOBILE_PAYMENT_CONFIRMATION = 3
export const SUBSCRIPTION_CREATE_STEP_BANK_PAYMENT = 4
export const SUBSCRIPTION_CREATE_STEP_PAYMENT_FAILED = 5

export const SUBSCRIPTION_UPGRADE_STEP_INITIAL = 0
export const SUBSCRIPTION_UPGRADE_STEP_PROVIDERS = 1
export const SUBSCRIPTION_UPGRADE_STEP_MOBILE_PAYMENT = 2
export const SUBSCRIPTION_UPGRADE_STEP_MOBILE_PAYMENT_CONFIRMATION = 3
export const SUBSCRIPTION_UPGRADE_STEP_BANK_PAYMENT = 4
export const SUBSCRIPTION_UPGRADE_STEP_PAYMENT_FAILED = 5

export const SUBSCRIPTION_CARD_METHOD = "stripe"
export const SUBSCRIPTION_MOBILE_METHOD = "zlick"
export const SUBSCRIPTION_BANK_METHOD = "bank"

export const SUBSCRIPTION_STATE_PENDING = "pending"
export const SUBSCRIPTION_STATE_UPGRADING = "upgrading"
export const SUBSCRIPTION_STATE_ACTIVE = "active"
export const SUBSCRIPTION_STATE_CANCELLATION_PENDING = "cancellation_pending"
export const SUBSCRIPTION_STATE_CANCELED = "canceled"
export const SUBSCRIPTION_STATE_ENDED = "ended"
export const SUBSCRIPTION_STATE_FAILED = "failed"

export const SUBSCRIPTION_CREATE_TYPE = "create"
export const SUBSCRIPTION_UPGRADE_TYPE = "upgrade"

export const PLAN_PERIOD_MONTH = "month"
export const PLAN_PERIOD_YEAR = "year"

export const PLAN_STANDARD = "standard"
export const PLAN_SILVER = "silver"
export const PLAN_GOLD = "gold"
